import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as DeleteIcon } from '../../../assets/icons/delete.svg';
import { pathJoin } from '../../../services/api';
import { useHasPermission } from '../../../services/auth/auth';
import { css } from '../../../services/css';
import { AddAuthorizedUser } from '../../shared/actions/actionButtons';
import { DeleteResource } from '../../shared/actions/deleteResource';
import { QueryGrid } from '../../shared/grid/queryGrid/queryGrid';
import { Button } from '../../shared/inputs/button';
import { Email } from '../../shared/links/email';
import { SYSTEM, USER } from '../../../permissions';

import styles from './authorizedUserList.module.css';

const writePermissions = [SYSTEM.WRITE, USER.READ];
const readPermissions = [SYSTEM.READ];
const readUserPermissions = [USER.READ];

export const AuthorizedUserList = ({scope, ...props}) => {

    const [authorizedUserToDelete, setAuthorizedUserToDelete] = useState(null);
    const [refreshToken, setRefreshToken] = useState('');
    const canWrite = useHasPermission(writePermissions);
    const canUserRead = useHasPermission(readUserPermissions);


    const refreshData = () => {
        setRefreshToken(Math.random().toString());
        props.refreshData();
    }

    const columns = () => {
        let c = {
            displayName: {
                label: 'Name',
                size: '1fr',
                passOnClick: true,
                formatFunction: r => canUserRead ? <Link to={pathJoin('/users', r.id)}>{r.displayName}</Link> : r.displayName,
            },
            mail: {
                label: 'Email',
                size: '1fr',
                formatFunction: r => <Email email={r.mail} />,
            },
            authorizedForSystemCount: {
                label: 'Systems',
                size: '96px',
                formatFunction: r => r.authorizedForSystemCount,
            },
        };

        if (canWrite)
            c.delete = {
                label: '',
                size: '64px',
                formatFunction: r => <Button
                    className={css(styles.Delete, 'icon')}
                    title='Delete Authorized User'
                    onClick={()  => setAuthorizedUserToDelete(r)}
                >
                    <DeleteIcon />
                </Button>,
            };

        return c;
    }


    return scope && <>
        <DeleteResource
            resourceName={'Authorized User'}
            name={authorizedUserToDelete?.displayName}
            customMessage={`Are you sure you want to remove ${authorizedUserToDelete?.displayName} as an authorized user?`}
            restEndpoint={pathJoin('/systemAccess', scope, 'authorizedUsers')}
            ids={[authorizedUserToDelete?.id]}
            successCallback={() => {
                setAuthorizedUserToDelete(null);
                refreshData();
            }}
            errorCallback={() => setAuthorizedUserToDelete(null)}
            cancelCallback={() => setAuthorizedUserToDelete(null)}
            prompt={authorizedUserToDelete !== null}
        />
        <QueryGrid
            queryParamPrefix='ua_'
            singleResourceName='User'
            pluralResourceName='Users'
            nameFunction={r => r.name}
            refreshToken={refreshToken}
            restEndpoint={pathJoin('/systemAccess', scope, 'authorizedUsers')}
            listUrl='/users'
            actions={[AddAuthorizedUser]}
            readPermissions={readPermissions}
            writePermissions={writePermissions}
            columns={columns()}
            scope={scope}
            {...props}
        />
    </>
}